import { ApiClient } from './ApiClient';

export interface ValueCount {
    value: string;
    count: number;
}

export interface TrainingListingsQueryParams {
    lang?: string;   
    page?: number; // default is 1
    q?: string;
}
export interface TrainingListing {
    HeadLine?: string;
    ThumbnailImage?: string;
    ThumbnailImage_AltText?: string;
    UpdatedDateTime?: string;
    StartPublish?: string;
    TopPreamble?: string;
    LinkURL?: string;
    TrainingImage?: string;
    LabelForReadMore?: string;
}

export interface TrainingListingsPageData {
    trainingListings: TrainingListing[];
    totalPages: number;
    totalTrainingListings: number;
}

export class TrainingListingsApi {
    private apiClient: ApiClient;

    constructor() {
        this.apiClient = new ApiClient('/api/traininglistings');
    }

    public getTrainingListings(params: TrainingListingsQueryParams = {}): Promise<TrainingListingsPageData> {
        return this.apiClient.get<TrainingListingsPageData>('pageData', params);
    }
}

// Export a single shared instance
export const trainingListingsApi = new TrainingListingsApi();